class DoclrEditModalCtrl {
    constructor(modalContext, isEdit, $rootScope) {
        'ngInject';
        this.context = modalContext;
        this.isEdit = isEdit;
        this.theRootScope = $rootScope;
    }
}